function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["align", "color", "family", "letterSpacing", "lineHeight", "opacity", "preset", "size", "transform", "weight", "component", "responsive", "uiTheme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { styledComponentsResponsiveStyles } from '../../utils/responsive';
import { getPreset } from '../Theme/selectors';
import withTheme from '../Theme/withTheme';
import typographyPropsToCss from './props-to-css';
var Typography = function Typography(_ref) {
  var align = _ref.align,
    color = _ref.color,
    family = _ref.family,
    letterSpacing = _ref.letterSpacing,
    lineHeight = _ref.lineHeight,
    opacity = _ref.opacity,
    preset = _ref.preset,
    size = _ref.size,
    transform = _ref.transform,
    weight = _ref.weight,
    Component = _ref.component,
    responsive = _ref.responsive,
    uiTheme = _ref.uiTheme,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, otherProps);
};
Typography.defaultProps = {
  align: null,
  color: null,
  className: null,
  component: 'span',
  family: null,
  letterSpacing: null,
  lineHeight: null,
  opacity: null,
  preset: null,
  responsive: [],
  size: null,
  transform: null,
  uiTheme: {},
  weight: null
};
var StyledTypography = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  var presetName = props.preset,
    uiTheme = props.uiTheme;
  var preset = getPreset(uiTheme, 'typography', presetName);
  return typographyPropsToCss(_objectSpread(_objectSpread({
    family: 'inherit',
    size: '1rem',
    transform: 'none',
    weight: 'normal',
    opacity: 1,
    letterSpacing: 'auto',
    lineHeight: 1.5
  }, preset), props));
}, function (props) {
  var preset = props.preset,
    uiTheme = props.uiTheme;
  var _getPreset = getPreset(uiTheme, 'typography', preset),
    presetResponsive = _getPreset.responsive;
  return styledComponentsResponsiveStyles(uiTheme, presetResponsive, function (breakpointProps) {
    return typographyPropsToCss(_objectSpread({
      uiTheme: uiTheme
    }, breakpointProps));
  });
}, function (props) {
  var responsive = props.responsive,
    uiTheme = props.uiTheme;
  return styledComponentsResponsiveStyles(uiTheme, responsive, function (breakpointProps) {
    var presetName = breakpointProps.preset;
    var preset = presetName ? getPreset(uiTheme, 'typography', presetName) : {};
    return typographyPropsToCss(_objectSpread(_objectSpread({
      uiTheme: uiTheme
    }, preset), breakpointProps));
  });
});
export default withTheme(StyledTypography);